<template>
  <div>
    <div style="margin-bottom: 0;" class="opc-cart__description" v-if="mx_is || isProAnnualBilledMonthlyToMonthlyDowngrade">
      {{ $t('billing.order_summary.taxes_desc2') }}
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import mx from './mx.vue';
import proAnnualBilledMonthlyMixin from '@/plans/ZOOM_MEETING/mixin/pro-annual-billed-monthly';

export default {
  mixins: [mx, proAnnualBilledMonthlyMixin],
};
</script>
